import y from "../../../../public/projects/nyati/projects/y.jpg";
import s from "../../../../public/projects/nyati/logo/s.png";
import evergreen from "../../../../public/projects/nyati/projects/ev.jpg"

// evoque
import overviewImageevoque from "../../../../public/projects/nyati/evoque/overview/1.webp";
import bannerDesktopImageevoque from "../../../../public/projects/nyati/evoque/banner/1.webp";
import bannerMobileImageevoque from "../../../../public/projects/nyati/evoque/banner/2.webp";
import Locationevoque from "../../../../public/projects/nyati/evoque/location/1.webp";
import Hightlightsevoque from "../../../../public/projects/nyati/evoque/highlights/1.webp";
import floorplan1evoque from "../../../../public/projects/nyati/evoque/floorplan/1.webp";
import floorplan2evoque from "../../../../public/projects/nyati/evoque/floorplan/2.webp";
import floorplan3evoque from "../../../../public/projects/nyati/evoque/floorplan/3.webp";
import floorplan4evoque from "../../../../public/projects/nyati/evoque/floorplan/4.webp";
import floorplan5evoque from "../../../../public/projects/nyati/evoque/floorplan/5.webp";
import locationiconevoque from "../../../../public/projects/nyati/evoque/overview/l.png";
import caliconevoque from "../../../../public/projects/nyati/evoque/overview/c.png";
import newlaunchiconevoque from "../../../../public/projects/nyati/evoque/overview/n.png";
import gallery1evoque from "../../../../public/projects/nyati/evoque/gallery/1.webp";
import gallery2evoque from "../../../../public/projects/nyati/evoque/gallery/2.webp";
import gallery3evoque from "../../../../public/projects/nyati/evoque/gallery/3.webp";
import gallery4evoque from "../../../../public/projects/nyati/evoque/gallery/4.webp";
import gallery5evoque from "../../../../public/projects/nyati/evoque/gallery/5.webp";

// projecttwo
import overviewImageprojecttwo from "../../../../public/projects/nyati/projecttwo/overview/1.webp";
import bannerDesktopImageprojecttwo from "../../../../public/projects/nyati/projecttwo/banner/1.webp";
import bannerMobileImageprojecttwo from "../../../../public/projects/nyati/projecttwo/banner/2.webp";
import Locationprojecttwo from "../../../../public/projects/nyati/projecttwo/location/1.webp";
import Hightlightsprojecttwo from "../../../../public/projects/nyati/projecttwo/highlights/1.webp";
import floorplan1projecttwo from "../../../../public/projects/nyati/projecttwo/floorplan/1.webp";
import floorplan2projecttwo from "../../../../public/projects/nyati/projecttwo/floorplan/2.webp";
import floorplan3projecttwo from "../../../../public/projects/nyati/projecttwo/floorplan/3.webp";
import floorplan4projecttwo from "../../../../public/projects/nyati/projecttwo/floorplan/4.webp";
import floorplan5projecttwo from "../../../../public/projects/nyati/projecttwo/floorplan/5.webp";
import locationiconprojecttwo from "../../../../public/projects/nyati/projecttwo/overview/l.png";
import caliconprojecttwo from "../../../../public/projects/nyati/projecttwo/overview/c.png";
import newlaunchiconprojecttwo from "../../../../public/projects/nyati/projecttwo/overview/n.png";
import gallery1projecttwo from "../../../../public/projects/nyati/projecttwo/gallery/1.webp";
import gallery2projecttwo from "../../../../public/projects/nyati/projecttwo/gallery/2.webp";
import gallery3projecttwo from "../../../../public/projects/nyati/projecttwo/gallery/3.webp";
import gallery4projecttwo from "../../../../public/projects/nyati/projecttwo/gallery/4.webp";
import gallery5projecttwo from "../../../../public/projects/nyati/projecttwo/gallery/5.webp";

// projectthree
import overviewImageprojectthree from "../../../../public/projects/nyati/projectthree/overview/1.webp";
import bannerDesktopImageprojectthree from "../../../../public/projects/nyati/projectthree/banner/1.webp";
import bannerMobileImageprojectthree from "../../../../public/projects/nyati/projectthree/banner/2.webp";
import Locationprojectthree from "../../../../public/projects/nyati/projectthree/location/1.webp";
import Hightlightsprojectthree from "../../../../public/projects/nyati/projectthree/highlights/1.webp";
import floorplan1projectthree from "../../../../public/projects/nyati/projectthree/floorplan/1.webp";
import floorplan2projectthree from "../../../../public/projects/nyati/projectthree/floorplan/2.webp";
import floorplan3projectthree from "../../../../public/projects/nyati/projectthree/floorplan/3.webp";
import floorplan4projectthree from "../../../../public/projects/nyati/projectthree/floorplan/4.webp";
import floorplan5projectthree from "../../../../public/projects/nyati/projectthree/floorplan/5.webp";
import locationiconprojectthree from "../../../../public/projects/nyati/projectthree/overview/l.png";
import caliconprojectthree from "../../../../public/projects/nyati/projectthree/overview/c.png";
import newlaunchiconprojectthree from "../../../../public/projects/nyati/projectthree/overview/n.png";
import gallery1projectthree from "../../../../public/projects/nyati/projectthree/gallery/1.webp";
import gallery2projectthree from "../../../../public/projects/nyati/projectthree/gallery/2.webp";
import gallery3projectthree from "../../../../public/projects/nyati/projectthree/gallery/3.webp";
import gallery4projectthree from "../../../../public/projects/nyati/projectthree/gallery/4.webp";
import gallery5projectthree from "../../../../public/projects/nyati/projectthree/gallery/5.webp";

// projectfour
import overviewImageprojectfour from "../../../../public/projects/nyati/projectfour/overview/1.webp";
import bannerDesktopImageprojectfour from "../../../../public/projects/nyati/projectfour/banner/1.webp";
import bannerMobileImageprojectfour from "../../../../public/projects/nyati/projectfour/banner/2.webp";
import Locationprojectfour from "../../../../public/projects/nyati/projectfour/location/1.webp";
import Hightlightsprojectfour from "../../../../public/projects/nyati/projectfour/highlights/1.webp";
import floorplan1projectfour from "../../../../public/projects/nyati/projectfour/floorplan/1.webp";
import floorplan2projectfour from "../../../../public/projects/nyati/projectfour/floorplan/2.webp";
import floorplan3projectfour from "../../../../public/projects/nyati/projectfour/floorplan/3.webp";
import floorplan4projectfour from "../../../../public/projects/nyati/projectfour/floorplan/4.webp";
import floorplan5projectfour from "../../../../public/projects/nyati/projectfour/floorplan/5.webp";
import locationiconprojectfour from "../../../../public/projects/nyati/projectfour/overview/l.png";
import caliconprojectfour from "../../../../public/projects/nyati/projectfour/overview/c.png";
import newlaunchiconprojectfour from "../../../../public/projects/nyati/projectfour/overview/n.png";
import gallery1projectfour from "../../../../public/projects/nyati/projectfour/gallery/1.webp";
import gallery2projectfour from "../../../../public/projects/nyati/projectfour/gallery/2.webp";
import gallery3projectfour from "../../../../public/projects/nyati/projectfour/gallery/3.webp";
import gallery4projectfour from "../../../../public/projects/nyati/projectfour/gallery/4.webp";
import gallery5projectfour from "../../../../public/projects/nyati/projectfour/gallery/5.webp";

// projectfive
import overviewImageprojectfive from "../../../../public/projects/nyati/projectfive/overview/1.webp";
import bannerDesktopImageprojectfive from "../../../../public/projects/nyati/projectfive/banner/1.webp";
import bannerMobileImageprojectfive from "../../../../public/projects/nyati/projectfive/banner/2.webp";
import Locationprojectfive from "../../../../public/projects/nyati/projectfive/location/1.webp";
import Hightlightsprojectfive from "../../../../public/projects/nyati/projectfive/highlights/1.webp";
import floorplan1projectfive from "../../../../public/projects/nyati/projectfive/floorplan/1.webp";
import floorplan2projectfive from "../../../../public/projects/nyati/projectfive/floorplan/2.webp";
import floorplan3projectfive from "../../../../public/projects/nyati/projectfive/floorplan/3.webp";
import floorplan4projectfive from "../../../../public/projects/nyati/projectfive/floorplan/4.webp";
import floorplan5projectfive from "../../../../public/projects/nyati/projectfive/floorplan/5.webp";
import locationiconprojectfive from "../../../../public/projects/nyati/projectfive/overview/l.png";
import caliconprojectfive from "../../../../public/projects/nyati/projectfive/overview/c.png";
import newlaunchiconprojectfive from "../../../../public/projects/nyati/projectfive/overview/n.png";
import gallery1projectfive from "../../../../public/projects/nyati/projectfive/gallery/1.webp";
import gallery2projectfive from "../../../../public/projects/nyati/projectfive/gallery/2.webp";
import gallery3projectfive from "../../../../public/projects/nyati/projectfive/gallery/3.webp";
import gallery4projectfive from "../../../../public/projects/nyati/projectfive/gallery/4.webp";
import gallery5projectfive from "../../../../public/projects/nyati/projectfive/gallery/5.webp";

// projectsix
import overviewImageprojectsix from "../../../../public/projects/nyati/projectsix/overview/1.webp";
import bannerDesktopImageprojectsix from "../../../../public/projects/nyati/projectsix/banner/1.webp";
import bannerMobileImageprojectsix from "../../../../public/projects/nyati/projectsix/banner/2.webp";
import Locationprojectsix from "../../../../public/projects/nyati/projectsix/location/1.webp";
import Hightlightsprojectsix from "../../../../public/projects/nyati/projectsix/highlights/1.webp";
import floorplan1projectsix from "../../../../public/projects/nyati/projectsix/floorplan/1.webp";
import floorplan2projectsix from "../../../../public/projects/nyati/projectsix/floorplan/2.webp";
import floorplan3projectsix from "../../../../public/projects/nyati/projectsix/floorplan/3.webp";
import floorplan4projectsix from "../../../../public/projects/nyati/projectsix/floorplan/4.webp";
import floorplan5projectsix from "../../../../public/projects/nyati/projectsix/floorplan/5.webp";
import locationiconprojectsix from "../../../../public/projects/nyati/projectsix/overview/l.png";
import caliconprojectsix from "../../../../public/projects/nyati/projectsix/overview/c.png";
import newlaunchiconprojectsix from "../../../../public/projects/nyati/projectsix/overview/n.png";
import gallery1projectsix from "../../../../public/projects/nyati/projectsix/gallery/1.webp";
import gallery2projectsix from "../../../../public/projects/nyati/projectsix/gallery/2.webp";
import gallery3projectsix from "../../../../public/projects/nyati/projectsix/gallery/3.webp";
import gallery4projectsix from "../../../../public/projects/nyati/projectsix/gallery/4.webp";
import gallery5projectsix from "../../../../public/projects/nyati/projectsix/gallery/5.webp";

// projectseven
import overviewImageprojectseven from "../../../../public/projects/nyati/projectseven/overview/1.webp";
import bannerDesktopImageprojectseven from "../../../../public/projects/nyati/projectseven/banner/1.webp";
import bannerMobileImageprojectseven from "../../../../public/projects/nyati/projectseven/banner/2.webp";
import Locationprojectseven from "../../../../public/projects/nyati/projectseven/location/1.webp";
import Hightlightsprojectseven from "../../../../public/projects/nyati/projectseven/highlights/1.webp";
import floorplan1projectseven from "../../../../public/projects/nyati/projectseven/floorplan/1.webp";
import floorplan2projectseven from "../../../../public/projects/nyati/projectseven/floorplan/2.webp";
import floorplan3projectseven from "../../../../public/projects/nyati/projectseven/floorplan/3.webp";
import floorplan4projectseven from "../../../../public/projects/nyati/projectseven/floorplan/4.webp";
import floorplan5projectseven from "../../../../public/projects/nyati/projectseven/floorplan/5.webp";
import locationiconprojectseven from "../../../../public/projects/nyati/projectseven/overview/l.png";
import caliconprojectseven from "../../../../public/projects/nyati/projectseven/overview/c.png";
import newlaunchiconprojectseven from "../../../../public/projects/nyati/projectseven/overview/n.png";
import gallery1projectseven from "../../../../public/projects/nyati/projectseven/gallery/1.webp";
import gallery2projectseven from "../../../../public/projects/nyati/projectseven/gallery/2.webp";
import gallery3projectseven from "../../../../public/projects/nyati/projectseven/gallery/3.webp";
import gallery4projectseven from "../../../../public/projects/nyati/projectseven/gallery/4.webp";
import gallery5projectseven from "../../../../public/projects/nyati/projectseven/gallery/5.webp";

// projecteight
import overviewImageprojecteight from "../../../../public/projects/nyati/projecteight/overview/1.webp";
import bannerDesktopImageprojecteight from "../../../../public/projects/nyati/projecteight/banner/1.webp";
import bannerMobileImageprojecteight from "../../../../public/projects/nyati/projecteight/banner/2.webp";
import Locationprojecteight from "../../../../public/projects/nyati/projecteight/location/1.webp";
import Hightlightsprojecteight from "../../../../public/projects/nyati/projecteight/highlights/1.webp";
import floorplan1projecteight from "../../../../public/projects/nyati/projecteight/floorplan/1.webp";
import floorplan2projecteight from "../../../../public/projects/nyati/projecteight/floorplan/2.webp";
import floorplan3projecteight from "../../../../public/projects/nyati/projecteight/floorplan/3.webp";
import floorplan4projecteight from "../../../../public/projects/nyati/projecteight/floorplan/4.webp";
import floorplan5projecteight from "../../../../public/projects/nyati/projecteight/floorplan/5.webp";
import locationiconprojecteight from "../../../../public/projects/nyati/projecteight/overview/l.png";
import caliconprojecteight from "../../../../public/projects/nyati/projecteight/overview/c.png";
import newlaunchiconprojecteight from "../../../../public/projects/nyati/projecteight/overview/n.png";
import gallery1projecteight from "../../../../public/projects/nyati/projecteight/gallery/1.webp";
import gallery2projecteight from "../../../../public/projects/nyati/projecteight/gallery/2.webp";
import gallery3projecteight from "../../../../public/projects/nyati/projecteight/gallery/3.webp";
import gallery4projecteight from "../../../../public/projects/nyati/projecteight/gallery/4.webp";
import gallery5projecteight from "../../../../public/projects/nyati/projecteight/gallery/5.webp";

// projectnine
import overviewImageprojectnine from "../../../../public/projects/nyati/projectnine/overview/1.webp";
import bannerDesktopImageprojectnine from "../../../../public/projects/nyati/projectnine/banner/1.webp";
import bannerMobileImageprojectnine from "../../../../public/projects/nyati/projectnine/banner/2.webp";
import Locationprojectnine from "../../../../public/projects/nyati/projectnine/location/1.webp";
import Hightlightsprojectnine from "../../../../public/projects/nyati/projectnine/highlights/1.webp";
import floorplan1projectnine from "../../../../public/projects/nyati/projectnine/floorplan/1.webp";
import floorplan2projectnine from "../../../../public/projects/nyati/projectnine/floorplan/2.webp";
import floorplan3projectnine from "../../../../public/projects/nyati/projectnine/floorplan/3.webp";
import floorplan4projectnine from "../../../../public/projects/nyati/projectnine/floorplan/4.webp";
import floorplan5projectnine from "../../../../public/projects/nyati/projectnine/floorplan/5.webp";
import locationiconprojectnine from "../../../../public/projects/nyati/projectnine/overview/l.png";
import caliconprojectnine from "../../../../public/projects/nyati/projectnine/overview/c.png";
import newlaunchiconprojectnine from "../../../../public/projects/nyati/projectnine/overview/n.png";
import gallery1projectnine from "../../../../public/projects/nyati/projectnine/gallery/1.webp";
import gallery2projectnine from "../../../../public/projects/nyati/projectnine/gallery/2.webp";
import gallery3projectnine from "../../../../public/projects/nyati/projectnine/gallery/3.webp";
import gallery4projectnine from "../../../../public/projects/nyati/projectnine/gallery/4.webp";
import gallery5projectnine from "../../../../public/projects/nyati/projectnine/gallery/5.webp";

// projectten
import overviewImageprojectten from "../../../../public/projects/nyati/projectten/overview/1.webp";
import bannerDesktopImageprojectten from "../../../../public/projects/nyati/projectten/banner/1.webp";
import bannerMobileImageprojectten from "../../../../public/projects/nyati/projectten/banner/2.webp";
import Locationprojectten from "../../../../public/projects/nyati/projectten/location/1.webp";
import Hightlightsprojectten from "../../../../public/projects/nyati/projectten/highlights/1.webp";
import floorplan1projectten from "../../../../public/projects/nyati/projectten/floorplan/1.webp";
import floorplan2projectten from "../../../../public/projects/nyati/projectten/floorplan/2.webp";
import floorplan3projectten from "../../../../public/projects/nyati/projectten/floorplan/3.webp";
import floorplan4projectten from "../../../../public/projects/nyati/projectten/floorplan/4.webp";
import floorplan5projectten from "../../../../public/projects/nyati/projectten/floorplan/5.webp";
import locationiconprojectten from "../../../../public/projects/nyati/projectten/overview/l.png";
import caliconprojectten from "../../../../public/projects/nyati/projectten/overview/c.png";
import newlaunchiconprojectten from "../../../../public/projects/nyati/projectten/overview/n.png";
import gallery1projectten from "../../../../public/projects/nyati/projectten/gallery/1.webp";
import gallery2projectten from "../../../../public/projects/nyati/projectten/gallery/2.webp";
import gallery3projectten from "../../../../public/projects/nyati/projectten/gallery/3.webp";
import gallery4projectten from "../../../../public/projects/nyati/projectten/gallery/4.webp";
import gallery5projectten from "../../../../public/projects/nyati/projectten/gallery/5.webp";



export const developernyati = {
  properties: [
    {
      name: "Nyati Evoque",
      image: bannerMobileImageevoque,
      price: "2.58 Crore Onwards",
      state: "Pune",
      developer: "nyati",
      location: "Wadgaon Sheri, Pune",
      projectlocation: "Pune",
      bed: "3,4 BHK Apartments",
      size: "1,301 - 1,645 sq.ft.",
      url: `/nyati-evoque`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Nyati Evoque",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "2006",
  },
  about: `nyati, a 100% FDI funded real-estate developer, backed by nyati Holdings Pte. Ltd., Singapore, the real estate investing division of the AT Holdings group of companies. AT Capital, headquartered in Singapore, was established with the aim of capitalizing on global opportunities within both established and emerging sectors.`,
};


export const projectsnyati = {

  evoque: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageevoque,
      bannerMobileImage: bannerMobileImageevoque,
      textOverlay: "",
      data: {
        title: "Nyati Evoque",
        subtitle: "Wadgaon Sheri, Pune",
        starting_price: "₹ 2.58 Cr Onwards",
        payment_plan: "CLP",
        rerano: "On Request",
        status: "Under Construction"
      }
    },

    overview: {
      heading: "Nyati Evoque",
      description: [
        "Nyati Evoque in Wadgaon Sheri, Pune features thoughtfully designed 3 & 4 BHK residences that exude sophistication and comfort. Each home is spacious, well-ventilated, and crafted with attention to detail. Premium fittings, smart layouts, and ample natural light contribute to a seamless and luxurious living experience.",
        "Residents benefit from a wide range of modern amenities such as a clubhouse, swimming pool, fully equipped gym, landscaped gardens, indoor games, jogging track, children’s play area, and more. The project promotes both relaxation and active lifestyles.",
        "Strategically located, Nyati Evoque offers excellent connectivity to key areas like Kalyani Nagar, Viman Nagar, Koregaon Park, and Pune Airport. It is also in close proximity to major IT hubs including EON IT Park and Magarpatta City, along with reputed schools, hospitals, malls, and restaurants, making it a highly desirable address."
      ],
      keywordLinks: {},
      image: overviewImageevoque,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconevoque,
          title: "₹ 2.58 Cr Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfour,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: caliconevoque,
          title: "Under Construction",
          subtitle: "Status",
        }
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "1,301 - 1,343 sq.ft.",
          price: "₹ 2.58 Cr - ₹ 2.66 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "1,578 - 1,645 sq.ft.",
          price: "₹ 3.13 Cr - ₹ 3.26 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "1,301 - 1,343 sq.ft.",
        price: "₹ 2.58 Cr - ₹ 2.66 Cr",
        image: floorplan1evoque,
      },
      {
        type: "4 BHK",
        area: "1,578 - 1,645 sq.ft.",
        price: "₹ 3.13 Cr - ₹ 3.26 Cr",
        image: floorplan2evoque,
      }
    ],

    highlights: {
      images: Hightlightsevoque,
      tagline: "Highlights",
      features: [
        "Elegant and modern architecture with a focus on luxury living.",
        "Encircled by the largest and most recognizable IT parks.",
        "Strategically located in Wadgaon Sheri with excellent city access.",
        "Close proximity to major work hubs like EON IT Park and Magarpatta.",
        "Blends urban living with nature – featuring open spaces and lush greenery.",
      ],
    },

    location: {
      image: Locationevoque,
      data: [
        {
          airport: {
            distance_time: "4.7 Km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "1.5 Km",
            name: "Christ College"
          },
          railwayormetro: {
            distance_time: "7.2 Km",
            name: "Pune Railway Station"
          },
          hospital: {
            distance_time: "4.6 Km",
            name: "Columbia Asia Hospital"
          },
          mall: {
            distance_time: "2.2 Km",
            name: "Hyatt Pune"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1evoque },
        { image: gallery2evoque },
        { image: gallery3evoque },
        { image: gallery4evoque },
        { image: gallery5evoque },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Nyati Evoque, kindly share more details.",
    },

    faq: [
      {
        question: "What types of configurations are available at Nyati Evoque?",
        answer: "Nyati Evoque offers luxurious 3 BHK and 4 BHK apartments.",
      },
      {
        question: "What are the amenities provided in Nyati Evoque?",
        answer: "Amenities include a clubhouse, swimming pool, gymnasium, and landscaped gardens.",
      },
      {
        question: "Is Nyati Evoque a RERA-registered project?",
        answer: "Yes, Nyati Evoque is RERA-registered.",
      },
      {
        question: "How is the connectivity of Nyati Evoque?",
        answer: "Nyati Evoque enjoys excellent connectivity to IT hubs like Magarpatta and EON IT Park.",
      },
      {
        question: "Who is the developer of Nyati Evoque?",
        answer: "Nyati Evoque is developed by Nyati Group.",
      },
      {
        question: "Is there sufficient open space and greenery in the project?",
        answer: "Yes, the project is designed with landscaped open spaces and greenery.",
      },
      {
        question: "What is the status of the project – ready-to-move or under construction?",
        answer: "As of now, Nyati Evoque is an ongoing project.",
      },
      {
        question: "Are there any schools or colleges nearby?",
        answer: "Yes, reputed institutions like Bishop’s School, Symbiosis, and Lexicon International are nearby.",
      },
      {
        question: "Is Nyati Evoque a good investment option?",
        answer: "Absolutely. Its strategic location, luxury offerings, and the reputation of Nyati Group make it a solid investment for end-users and investors alike.",
      },
      {
        question: "Where is Nyati Evoque located?",
        answer: "The project is situated in Wadgaon Sheri, a well-developed and highly connected area in Pune, close to Kalyani Nagar, Viman Nagar, and Pune Airport.",
      }
    ],

    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry",
      to_email: "leads@gurugram-property.com",
    },
  },
  projecttwo: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecttwo,
      bannerMobileImage: bannerMobileImageprojecttwo,
      textOverlay: "",
      data: {
        title: "nyati The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "nyati The Trillion",
      description: [
        "nyati The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by nyati Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at nyati Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at nyati Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of nyati The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "nyati": "/developers/nyati",
      },
      image: overviewImageprojecttwo,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecttwo,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecttwo,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecttwo,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecttwo,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecttwo,
      }
    ],

    highlights: {
      images: Hightlightsprojecttwo,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecttwo,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecttwo },
        { image: gallery2projecttwo },
        { image: gallery3projecttwo },
        { image: gallery4projecttwo },
        { image: gallery5projecttwo },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in nyati The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is nyati The Trillion located?",
        answer: `nyati The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at nyati The Trillion?",
        answer: `nyati The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in nyati The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at nyati The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, nyati The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of nyati The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at nyati The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of nyati The Trillion?",
        answer: `nyati The Trillion is developed by nyati Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is nyati The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, nyati The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from nyati The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectthree: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectthree,
      bannerMobileImage: bannerMobileImageprojectthree,
      textOverlay: "",
      data: {
        title: "nyati The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "nyati The Trillion",
      description: [
        "nyati The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by nyati Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at nyati Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at nyati Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of nyati The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {},
      image: overviewImageprojectthree,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectthree,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectthree,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectthree,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectthree,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectthree,
      }
    ],

    highlights: {
      images: Hightlightsprojectthree,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectthree,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectthree },
        { image: gallery2projectthree },
        { image: gallery3projectthree },
        { image: gallery4projectthree },
        { image: gallery5projectthree },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in nyati The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is nyati The Trillion located?",
        answer: `nyati The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at nyati The Trillion?",
        answer: `nyati The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in nyati The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at nyati The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, nyati The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of nyati The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at nyati The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of nyati The Trillion?",
        answer: `nyati The Trillion is developed by nyati Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is nyati The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, nyati The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from nyati The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfour,
      bannerMobileImage: bannerMobileImageprojectfour,
      textOverlay: "",
      data: {
        title: "nyati The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "nyati The Trillion",
      description: [
        "nyati The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by nyati Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at nyati Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at nyati Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of nyati The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "nyati": "/developers/nyati",
      },
      image: overviewImageprojectfour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfour,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfour,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfour,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfour,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfour,
      }
    ],

    highlights: {
      images: Hightlightsprojectfour,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfour,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfour },
        { image: gallery2projectfour },
        { image: gallery3projectfour },
        { image: gallery4projectfour },
        { image: gallery5projectfour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in nyati The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is nyati The Trillion located?",
        answer: `nyati The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at nyati The Trillion?",
        answer: `nyati The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in nyati The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at nyati The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, nyati The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of nyati The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at nyati The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of nyati The Trillion?",
        answer: `nyati The Trillion is developed by nyati Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is nyati The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, nyati The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from nyati The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfive: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfive,
      bannerMobileImage: bannerMobileImageprojectfive,
      textOverlay: "",
      data: {
        title: "nyati The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "nyati The Trillion",
      description: [
        "nyati The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by nyati Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at nyati Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at nyati Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of nyati The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "nyati": "/developers/nyati",
      },
      image: overviewImageprojectfive,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfive,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfive,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfive,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfive,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfive,
      }
    ],

    highlights: {
      images: Hightlightsprojectfive,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfive,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfive },
        { image: gallery2projectfive },
        { image: gallery3projectfive },
        { image: gallery4projectfive },
        { image: gallery5projectfive },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in nyati The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is nyati The Trillion located?",
        answer: `nyati The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at nyati The Trillion?",
        answer: `nyati The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in nyati The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at nyati The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, nyati The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of nyati The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at nyati The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of nyati The Trillion?",
        answer: `nyati The Trillion is developed by nyati Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is nyati The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, nyati The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from nyati The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectsix: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectsix,
      bannerMobileImage: bannerMobileImageprojectsix,
      textOverlay: "",
      data: {
        title: "nyati The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "nyati The Trillion",
      description: [
        "nyati The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by nyati Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at nyati Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at nyati Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of nyati The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "nyati": "/developers/nyati",
      },
      image: overviewImageprojectsix,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectsix,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectsix,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectsix,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectsix,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectsix,
      }
    ],

    highlights: {
      images: Hightlightsprojectsix,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectsix,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectsix },
        { image: gallery2projectsix },
        { image: gallery3projectsix },
        { image: gallery4projectsix },
        { image: gallery5projectsix },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in nyati The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is nyati The Trillion located?",
        answer: `nyati The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at nyati The Trillion?",
        answer: `nyati The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in nyati The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at nyati The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, nyati The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of nyati The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at nyati The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of nyati The Trillion?",
        answer: `nyati The Trillion is developed by nyati Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is nyati The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, nyati The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from nyati The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectseven: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectseven,
      bannerMobileImage: bannerMobileImageprojectseven,
      textOverlay: "",
      data: {
        title: "nyati The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "nyati The Trillion",
      description: [
        "nyati The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by nyati Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at nyati Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at nyati Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of nyati The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "nyati": "/developers/nyati",
      },
      image: overviewImageprojectseven,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectseven,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectseven,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectseven,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectseven,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectseven,
      }
    ],

    highlights: {
      images: Hightlightsprojectseven,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectseven,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectseven },
        { image: gallery2projectseven },
        { image: gallery3projectseven },
        { image: gallery4projectseven },
        { image: gallery5projectseven },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in nyati The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is nyati The Trillion located?",
        answer: `nyati The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at nyati The Trillion?",
        answer: `nyati The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in nyati The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at nyati The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, nyati The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of nyati The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at nyati The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of nyati The Trillion?",
        answer: `nyati The Trillion is developed by nyati Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is nyati The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, nyati The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from nyati The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecteight: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecteight,
      bannerMobileImage: bannerMobileImageprojecteight,
      textOverlay: "",
      data: {
        title: "nyati The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "nyati The Trillion",
      description: [
        "nyati The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by nyati Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at nyati Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at nyati Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of nyati The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "nyati": "/developers/nyati",
      },
      image: overviewImageprojecteight,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecteight,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecteight,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecteight,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecteight,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecteight,
      }
    ],

    highlights: {
      images: Hightlightsprojecteight,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecteight,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecteight },
        { image: gallery2projecteight },
        { image: gallery3projecteight },
        { image: gallery4projecteight },
        { image: gallery5projecteight },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in nyati The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is nyati The Trillion located?",
        answer: `nyati The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at nyati The Trillion?",
        answer: `nyati The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in nyati The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at nyati The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, nyati The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of nyati The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at nyati The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of nyati The Trillion?",
        answer: `nyati The Trillion is developed by nyati Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is nyati The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, nyati The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from nyati The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectnine: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectnine,
      bannerMobileImage: bannerMobileImageprojectnine,
      textOverlay: "",
      data: {
        title: "nyati The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "nyati The Trillion",
      description: [
        "nyati The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by nyati Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at nyati Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at nyati Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of nyati The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "nyati": "/developers/nyati",
      },
      image: overviewImageprojectnine,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectnine,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectnine,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectnine,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectnine,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectnine,
      }
    ],

    highlights: {
      images: Hightlightsprojectnine,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectnine,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectnine },
        { image: gallery2projectnine },
        { image: gallery3projectnine },
        { image: gallery4projectnine },
        { image: gallery5projectnine },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in nyati The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is nyati The Trillion located?",
        answer: `nyati The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at nyati The Trillion?",
        answer: `nyati The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in nyati The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at nyati The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, nyati The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of nyati The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at nyati The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of nyati The Trillion?",
        answer: `nyati The Trillion is developed by nyati Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is nyati The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, nyati The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from nyati The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectten: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectten,
      bannerMobileImage: bannerMobileImageprojectten,
      textOverlay: "",
      data: {
        title: "nyati The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "nyati The Trillion",
      description: [
        "nyati The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by nyati Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at nyati Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at nyati Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of nyati The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "nyati": "/developers/nyati",
      },
      image: overviewImageprojectten,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectten,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectten,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectten,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectten,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectten,
      }
    ],

    highlights: {
      images: Hightlightsprojectten,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectten,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectten },
        { image: gallery2projectten },
        { image: gallery3projectten },
        { image: gallery4projectten },
        { image: gallery5projectten },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in nyati The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is nyati The Trillion located?",
        answer: `nyati The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at nyati The Trillion?",
        answer: `nyati The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in nyati The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at nyati The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, nyati The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of nyati The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at nyati The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of nyati The Trillion?",
        answer: `nyati The Trillion is developed by nyati Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is nyati The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, nyati The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from nyati The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
